
<wiz-vgroup
      #gpMain
      width="100%"
      height="100%"
      verticalAlign="center"
      [wizTooltip]="tooltipText"
      [tooltipEnable]="tooltipEnable"
      [style.backgroundColor]="backgroundColor"
      [style.color]="fontColor"
      style="padding-left: 5px; padding-right: 5px;"
      gap="0"
      horizontalAlign="end">
    
      <wiz-hgroup width="100%" height="100%" verticalAlign="center" (click)="onSortRequested($event)">
        <wiz-hgroup width="100%" height="100%" verticalAlign="center">
          <wiz-label #lbl [wizTextBehavior]="'wordWrap'"
          [style.textAlign]="textAlign"
          [wizLabel]="params.displayName"
          [tooltipText]="params.displayName"
          [wizNbLine]="3"
          width="100%"></wiz-label>
        </wiz-hgroup>
  
        <wiz-icon style="cursor: pointer;"
        [style.backgroundColor]="backgroundColor"
        [style.color]="fontColor">{{arrowKind}}</wiz-icon>
  
        <wiz-icon
          #icoSettings
          [wizTooltip]="'$.widget.configure.column.$'"
          *ngIf="params.enableMenu && canUpdateTemplates"
          style="cursor: pointer;"
          [style.backgroundColor]="backgroundColor"
          [style.color]="fontColor"
          (click)="showSettingsPop($event)"
        >settings</wiz-icon>
      </wiz-hgroup>



      <wiz-hgroup #gpMass wizValidationContainer width="100%" height="30px" *ngIf="showMass" horizontalAlign="end" verticalAlign="center">

        <filter-mass-renderer
          style="color: var(--grid-header-color) !important;"
          #ddext *ngIf="showMassDrop"
          [data]="fkd"
          [model]="model"
          [widget]="widget"
          [column]="column"
          [currentValue]="massValue"
          width="100%"        
        ></filter-mass-renderer>

        <wiz-checkbox #cb *ngIf="showMassBoolean" 
          style="color: var(--grid-header-color) !important;"
          [wizTriStateMode]="false" 
          [wizShowLabel]=false 
        ></wiz-checkbox>

        <wiz-text-input
          style="color: var(--grid-header-color) !important;"
          #ti *ngIf="showMassText"
          [wizShowClearButton]=true 
          [wizShowLabel]=false width="100%" minWidth="20px" class="noHintInput"
          [wizMaxChars]="wizMaxChars"
          [wizRestrict]="wizRestrict"
          wizValidator
        ></wiz-text-input>

        <wiz-numeric-input
          style="color: var(--grid-header-color) !important;"
          #ni *ngIf="showMassNumber"
          [wizShowClearButton]=true 
          [wizShowLabel]=false 
          wizFocusMode="PASS"
          class="noHintInput"
          [wizMaxChars]="20"
          [wizMinNumber]="wizMinNumber"
          [wizMaxNumber]="wizMaxNumber"
          [nbDecimal]="nbDecimal"
          wizValidator
          width="100%" minWidth="20px"
        ></wiz-numeric-input>

        <wiz-datefield #da *ngIf="showMassDate"
          style="color: var(--grid-header-color) !important;"
          [wizShowLabel]=false
          width="100%"
          [wizMinDate]="wizMinDate"
          [wizMaxDate]="wizMaxDate"
          wizValidator></wiz-datefield>
         
        <wiz-icon width="30px" height="30px"
          #icoApplyMass
          [wizTooltip]="'$.pivot.mass.edit.$'"
          [wizDisabled]="disableMassValue"
          style="cursor: pointer;"
          [style.backgroundColor]="'#00000000'"
          [style.color]="fontColor"
          [style.fontSize]="'24px'"
          (click)="applyMass($event)"
        >icon-validate</wiz-icon>

      </wiz-hgroup>
        

  </wiz-vgroup>